<template>
  <div class="flats-list">
    <!-- <div v-for="(flat, i) in orderedFlats" :key="i" class="flats__banners">
      <div v-if="flat.isBanner" class="flats-list-avd flats-list-avd__banner">
        <div colspan="7">
          <component
            :is="flat.component"
            :banner="flat.data"
            @click="(e, banner) => $emit('bannerClick', e, banner)"
          />
        </div>
      </div>
    </div> -->
    <template v-if="!secondLayoutType">
      <FlatCard
        v-for="(flat, index) in orderedFlats"
        :key="index"
        :flat-img="flat?.layout?.plan_image?.image_thumb"
        :room-count="
          isCommerce ? flat?.title : $filters.flatRoomNormalize(flat?.layout)
        "
        :flat-number="flat?.number"
        :flat-building="getBuildingDisplayName(flat?.building)"
        :flat-area="$filters.squareFormat(flat.layout.area)"
        :flat-floor="flat.floor.number"
        :flat-mortgage="formattedMortgagePayments[flat.id]"
        :flat-cost="$filters.priceFormat(flat.cost)"
        :data="flat"
        @click="routerPush(flat)"
      >
        <template #favorite>
          <FavouritesIcon :id="flat.id" />
        </template>
        <template #tags>
          <div class="flats-list__tags">
            <div
              v-if="flat.status === 'booked'"
              class="flats-list__tag btn btn-tag btn-tag-default"
            >
              <Icon icon="lock2" />{{
                $filters.bookedStatusNormalize(flat.layout.type)
              }}
            </div>
            <div
              v-if="flat?.properties?.without_down_payment"
              class="flats-list__tag btn btn-tag btn-tag-red"
            >
              <div class="hardcode-discount-text">Без первого взноса</div>
            </div>
            <div
              v-if="flat?.properties?.castom_sticker_2"
              class="flats-list__tag btn btn-tag btn-tag-red"
              v-html="flat?.properties?.castom_sticker_2"
            />
          </div>
        </template>
      </FlatCard>
    </template>
    <template v-else>
      <div class="flats-list__header">
        <ul>
          <li class="flats-list__header scheme">Схема</li>
          <li class="flats-list__header rooms">Комнатность</li>
          <li class="flats-list__header cost">Стоимость</li>
          <li class="flats-list__header features">Особенности</li>
        </ul>
      </div>
      <FlatCardNew
        v-for="(flat, index) in orderedFlats"
        :key="index"
        :flat-img="flat?.layout?.plan_image?.image_thumb"
        :room-count="
          isCommerce ? flat?.title : $filters.flatRoomNormalize(flat?.layout)
        "
        :flat-number="flat?.number"
        :flat-building="getBuildingDisplayName(flat?.building)"
        :flat-area="flat?.layout?.area"
        :flat-floor="flat?.floor?.number"
        :flat-mortgage="formattedMortgagePayments[flat?.id]"
        :flat-cost="$filters.priceFormaSymbol(flat?.cost)"
        :flat-id="flat?.id"
        :flat-status="flat?.status"
        :flat-discount="flat?.discount"
        :flat-layout="flat?.layout.type"
        :flat-tag="flat?.properties?.with_balcony"
        :tag-payment="flat?.properties?.without_down_payment"
        :data="flat"
        @click="routerPush(flat)"
      />
    </template>
  </div>
</template>

<script>
import _orderBy from "lodash/orderBy";
import FavouritesIcon from "@/components/UI/FavouritesIcon.vue";
import FlatCard from "@/components/FlatCard.vue";
import FlatCardNew from "@/components/FlatCardNew.vue";
export default {
  components: {
    FlatCard,
    FavouritesIcon,
    FlatCardNew,
  },
  inject: ["mainStore", "filterStore"],
  props: {
    flats: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    isCommerce: {
      type: Boolean,
      default: false,
    },
    banners: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    hidePrice: {
      type: Boolean,
      default: false,
    },
    secondLayoutType: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["bannerClick"],

  computed: {
    sortFilterActive() {
      return this.filterStore.state.filterSort;
    },

    orderedFlats() {
      let flats = this.flats;

      if (!this.showAll) {
        flats = flats.filter(
          (item) => this.$buildings[item.building]?.isAvailable
        );
      }

      flats = flats.filter((flat) => flat?.layout?.plan_image?.image_thumb);

      if (this.limit) {
        flats = flats.slice(0, this.limit);
      }

      // if (this.sortFilterActive) {
      //   switch (this.sortFilterActive) {
      //     case "price_asc":
      //       flats = _orderBy(flats, "discount_cost", "asc");
      //       break;
      //     case "price_desc":
      //       flats = _orderBy(flats, "discount_cost", "desc");
      //       break;
      //     case "area_asc":
      //       flats = _orderBy(flats, "layout.area", "asc");
      //       break;
      //     case "area_desc":
      //       flats = _orderBy(flats, "layout.area", "desc");
      //       break;
      //   }
      // }

      let bannerId = 0;
      const out = [];
      flats.forEach((item, i) => {
        if (i % 5 === 0) {
          if (this.banners.length > bannerId) {
            out.push(this.banners[bannerId]);
            bannerId++;
          }
        }
        out.push(item);
      });
      while (this.banners.length > bannerId) {
        out.push(this.banners[bannerId]);
        bannerId++;
      }

      return out;
    },

    mortgage() {
      return this.mainStore.state.data?.mortgage ?? {};
    },

    formattedMortgagePayments() {
      const result = {};
      this.orderedFlats.forEach((flat) => {
        const mortgageRate = this.mortgage[`rate_for_${flat.layout.type}s`];
        if (!mortgageRate) return;

        const initialInstalment = mortgageRate.initial_instalment || 0;
        const initPay = flat.cost * (initialInstalment / 100);

        const payment = this.$filters.mortgagePay({
          cost: flat.cost,
          initPay: initPay,
          applyCoef: this.mortgage?.apply_coefficient,
          coef: this.mortgage?.coefficient,
          percent: mortgageRate.rate,
          firsYearCoefficient: mortgageRate.coefficient,
          years: this.mortgage?.max_mortgage_bank_time,
        });

        result[flat.id] = this.$filters.priceFormat(payment);
      });

      return result;
    },
  },

  methods: {
    routeBuilder(flat) {
      return {
        name: "SearchPlanFlat",
        params: {
          korp: flat.building,
          sec: flat.section,
          floor: flat.floor?.number,
          fnumb: flat.number_on_floor,
          numb: flat.number,
          quantity: flat.layout?.room_count,
          id: flat.uuid,
        },
      };
    },

    routerPush(flat) {
      this.$router.push(this.routeBuilder(flat));
    },

    getBuildingDisplayName(building) {
      const names = {
        1: "3.1",
        2: "2.1",
      };
      return names[building] || building;
    },
  },
};
</script>

<style scoped>
.flats-list {
  font-weight: normal;
  width: 100%;
}

.flats-list__view-button {
  position: relative;
}

.flats-list__view-button::after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.hardcode-discount-text {
  font-size: 12px;
  color: #fff !important;
  display: inline-flex;
  align-items: center;
}

.hardcode-discount-text span {
  color: #fff !important;
  font-weight: 700;
  font-size: 20px;
  margin-right: 4px;
}

.flats-list__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 24px;
}

.flats-list__tag {
  white-space: nowrap;
}

.flats-list__content {
  padding-right: 20px;
}

.flats-list__label {
  line-height: 1;
}

.flats-list-avd {
  padding: 0 !important;
}

.flats-list-avd__banner {
  border-bottom: unset;
}

.flats-list-avd__banner :deep(.banner) {
  margin-top: 12px;
}

.flats-list :deep(.flat-card-wrapper:first-child .flat-card) {
  border-top: none !important;
}

.flats-list__header ul {
  list-style-type: none;
  display: flex;
  gap: 35px;
  margin: 0;
  margin-bottom: 15px;
}
.flats-list__header.scheme {
  width: 117px;
}
.flats-list__header.rooms {
  width: 220px;
}
.flats-list__header.features {
  max-width: 435px;
  margin-left: auto;
  flex: 1;
}
@media (max-width: 1279px) {
  .flats-list__header.features {
    max-width: 288px;
  }
}

@media (max-width: 992px) {
  .flats-list__header {
    display: none;
  }
}
</style>
